import React from "react";
import RatingBar from './RatingBar.jsx';
import Helper from '../functions/Helper.js'

export default class AdditionalInfo extends React.Component {
  render(){
    return(
      <div className={this.props.className} popper={this.props.popper} style={{...this.props.style,borderRadius:5,boxShadow:"rgba(0, 0, 0, 0.24) 0px 3px 8px",width:300,padding:"10px 10px 20px 10px",backgroundColor:"#fff",border:"1px solid #ccc"}}>
        {["traction","cushion","materials","support","fit","outdoor","durability"].map((x)=>
          this.props.shoe[x] && this.props.shoe[x]!=="-1" && <RatingBar key={x}  size="small" category={Helper.capitalize(x)} rating={this.props.shoe[x]}/>
        )}
      </div>
    );
  }
}
